module.exports = __webpack_public_path__ + "media/images/banner-saudi-arabia-aaa2f07d59d12328f3b23cda6e0cb18b.jpg";